"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function SelectedAssets(_ref) {
  var asset = _ref.asset;

  if (!asset) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bulk-actions__selectedAsset-list__content"
  }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
    height: 80,
    width: 80,
    asset: asset,
    hideFileTypeIcon: true,
    rounded: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bulk-actions__selectedAsset-list__content__asset-details"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true,
    noMargin: true,
    ellipsisOverflow: true
  }, asset.title), asset.description ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: "bottom",
    ellipsisOverflow: true,
    label: true
  }, asset.description) : null));
}

var _default = (0, _commonReact.withAssetSelector)(SelectedAssets);

exports.default = _default;